<template>
  <div class="fachabteilungen container page-content">
    <h1>Telefonnummern der Medizinischen Fachabteilungen</h1>

    <div class="kliniken-desktop">
      <klinik-instance
          v-for="klinik in kliniken"
          :key="klinik.id"
          :klinik="klinik"
      />
    </div>

    <div class="mt-4">
      <p>Den Beauftragten für Medizinproduktesicherheit am Universitätsklinikum Frankfurt erreichen Sie derzeit unter
        <a href="mailto:medizinproduktesicherheit@host-gmbh.com">medizinproduktesicherheit@host-gmbh.com</a>.</p>
      <p>Die Ethikkommission am Universitätsklinikum Frankfurt erreichen Sie unter
        <a href="mailto:ethik@med.uni-frankfurt.de">ethik@med.uni-frankfurt.de</a>,
        <a href="tel:06963013758">Tel. 069 6301 3758</a>.</p>
    </div>

  </div>
</template>

<script>
import KlinikInstance from "@/components/KlinikInstance.vue";

export default {
  name: 'Fachabteilungen',

  components: {KlinikInstance},

  computed: {
    kliniken() {return this.$store.state.kliniken},
  },

  created() {
    document.title = this.$route.meta.title;
    window.scrollTo(0, 0);
  },
}
</script>
